<template>
  <div class="q-pa-lg text-center">
    <div class="text-body1 text-weight-bold q-mb-sm">
      Import New Posts
    </div>
    <p class="text-body1">
      You have been requested to import new posts.
    </p>
    <import-posts-btn
      v-if="request.assignee === 'client'"
      :account="account"
      label="Import Posts"
      color="primary"
      rounded
      class="q-mt-sm"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account, ReconnectRequest } from '@/social/types';
import ImportPostsBtn from './ImportPostsBtn.vue';

export default defineComponent({
  components: { ImportPostsBtn },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  computed: {
    request(): ReconnectRequest|null {
      return this.account.reconnectRequest;
    },
  },
});
</script>
